require('../../modules/es6.object.is-frozen');
module.exports = require('../../modules/$.core').Object.isFrozen;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/is-frozen.js
 ** module id = 387
 ** module chunks = 0
 **/